import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CloseModal, Modal } from '../../modal.models';

@Component({
	selector: 'cmv-get-debit-card-modal',
	templateUrl: './get-debit-card-modal.component.html',
	styleUrls: ['./get-debit-card-modal.component.scss'],
})
export class GetDebitCardModalComponent implements Modal, CloseModal {
	@Input()
	isModalVisible: boolean;
	@Output() acceptDebitCardEvent: EventEmitter<boolean> = new EventEmitter();

	constructor() {}

	hideGetDebitCardModal(): void {
		this.isModalVisible = false;
	}

	onCloseModal(): void {
		this.onRejectDebitCard();
	}

	onRejectDebitCard(): void {
		this.acceptDebitCardEvent.emit(false);
		this.hideGetDebitCardModal();
	}

	onAcceptDebitCard(): void {
		this.acceptDebitCardEvent.emit(true);
		this.hideGetDebitCardModal();
	}
}
